export default __webpack_public_path__ + "static/media/templateEmpty.997ea82d.svg";